import PropTypes from "prop-types";

export const AACTType = PropTypes.shape({
  version: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      calculated_values: PropTypes.arrayOf(
        PropTypes.shape({
          actual_duration: PropTypes.number,
          maximum_age: PropTypes.number,
          minumum_age: PropTypes.number,
          number_of_nsae_subjects: PropTypes.number,
          number_of_sae_subjects: PropTypes.number,
        })
      ),
      completion_date: PropTypes.string,
      conditions: PropTypes.arrayOf(PropTypes.string),
      designs: PropTypes.arrayOf(
        PropTypes.shape({
          allocation: PropTypes.string,
          intervention_model: PropTypes.string,
          intervention_model_descr: PropTypes.string,
          observational_model: PropTypes.string,
          primary_purpose: PropTypes.string,
          time_perspective: PropTypes.string,
        })
      ),
      eligibilities: PropTypes.arrayOf(
        PropTypes.shape({
          criteria: PropTypes.string,
          gender: PropTypes.string,
          gender_based: PropTypes.bool,
          gender_description: PropTypes.string,
          healthy_volunteers: PropTypes.string,
          maximum_age: PropTypes.string,
          minimum_age: PropTypes.string,
          population: PropTypes.string,
          sampling_method: PropTypes.string,
        })
      ),
      facilities: PropTypes.arrayOf(
        PropTypes.shape({
          city: PropTypes.string,
          country: PropTypes.string,
          name: PropTypes.string,
          state: PropTypes.string,
          status: PropTypes.string,
        })
      ),
      genes: PropTypes.arrayOf(PropTypes.string),
      interventions: PropTypes.arrayOf(PropTypes.shape({})),
      is_fda_drug: PropTypes.bool,
      nct_id: PropTypes.string,
      outcomes: PropTypes.arrayOf(
        PropTypes.shape({
          description: PropTypes.string,
          outcome_type: PropTypes.string,
          param_type: PropTypes.string,
          population: PropTypes.string,
          time_frame: PropTypes.string,
          title: PropTypes.string,
          units: PropTypes.string,
        })
      ),
      overall_officials: PropTypes.arrayOf(PropTypes.shape({})),
      phenotypes: PropTypes.arrayOf(PropTypes.string),
      population: PropTypes.string,
      // eslint-disable-next-line react/forbid-prop-types
      pub_med_references: PropTypes.arrayOf(PropTypes.any),
      source: PropTypes.string,
      sponsors: PropTypes.arrayOf(PropTypes.shape({})),
      status: PropTypes.string,
      title: PropTypes.string,
      unidentified_keywords: PropTypes.arrayOf(PropTypes.string),
    })
  ),
});
